var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"relative w-16 h-16"},[_c('div',{ref:"pulse",staticClass:"absolute inset-0 w-full h-full border border-aqua-500 rounded-full"})])])}
var staticRenderFns = []

export { render, staticRenderFns }